var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"box",staticClass:"box",attrs:{"id":"box"}},[_vm._m(0),_c('topo')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[_c('div',{staticClass:"title-logo"}),_c('div',{staticClass:"title-txt"},[_vm._v("知识图谱本体结构")])])
}]

export { render, staticRenderFns }